<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <button class="btn btn-secondary mr-2" @click="add_country">{{ 'add_country' | t }}</button>
      <button class="btn btn-primary" @click="spin($event, save)">{{ 'update_formats' | t }}</button>
    </div>
    <div class="card mb-4">
      <div class="form-group mb-0">
        <input class="form-control mb-0 search-input" placeholder="Please enter country-code" v-model="search_query" />
      </div>
    </div>
    <div class="card mb-3 p-3">
      <table>
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ 'country_code' | t }}</th>
              <th>{{ 'formats' | t }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(zip, index) in zipcodes">
              <td>{{ zip.country_code }}</td>
              <td class="form-group">
                <input
                  class="form-control"
                  v-model="zip.formats"
                  @change="register_format_change(zip)"
                  @keydown="validate_key"
                />
              </td>
              <td class="text-right">
                <span><i class="fa fa-ban" @click="delete_country(zip, index)"></i></span>
              </td>
            </tr>
            <tr v-for="(zip, index) in new_countries">
              <td class="form-group">
                <input class="form-control" v-model="zip.country_code" />
              </td>
              <td class="form-group">
                <input class="form-control" v-model="zip.formats" @keydown="validate_key" />
              </td>
              <td class="text-right">
                <span><i class="fa fa-ban" @click="delete_country(zip, index)"></i></span>
              </td>
            </tr>
          </tbody>
        </table>
      </table>
    </div>
    <div class="card mb-3 p-3">
      <p>Country codes must be unique.</p>
      <p>Formats should be separated with a comma (,).</p>
      <p>Formats use "A" for alpha and "N" for number.</p>
      <p>Formats may only contain A,N and space characters.</p>
      <p>Example: AN NAA,ANN NAA,AAN NAA</p>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import LazyTable from './../lazy-table.vue';

export default {
  data: function () {
    return {
      zipcodes: [],
      changes: {},
      new_countries: [],
      search_query: '',
      query: {
        sort: 'country_code'
      }
    };
  },
  watch: {
    search_query: function () {
      this.search();
    }
  },
  methods: {
    save: handle(async function () {
      let promises = [];
      _.each(this.changes, (x) => {
        promises.push(Api.update('address_validation_zip_formats', _.pick(x, ['id', 'formats'])));
      });
      _.each(this.new_countries, (x) => {
        promises.push(Api.create('address_validation_zip_formats', x));
      });

      await Promise.all(promises);

      Alerts.success({ title: 'Success', detail: 'Formats updated' });
    }),
    validate_key(e) {
      // 65 : A for alpha (A)
      // 78 : N for number (N)
      // 32 : space ( )
      // 8 : for backspace (⌫)
      // 188 : for comma (,)
      // 188 : for dash (-)
      if (e.which != 65 && e.which != 78 && e.which != 32 && e.which !== 8 && e.which !== 188 && e.which !== 189) {
        e.preventDefault();
        return false;
      }
    },
    register_format_change(zip) {
      if (typeof this.changes[zip.id] !== 'undefined') {
        return;
      }

      this.changes[zip.id] = zip;
    },
    add_country() {
      this.new_countries.push({
        country_code: '',
        formats: ''
      });
    },
    delete_country(zip, index) {
      if (typeof zip.id !== 'undefined') {
        Api.destroy('address_validation_zip_formats', zip.id);

        this.zipcodes.splice(index, 1);
      } else {
        this.new_countries.splice(index, 1);
      }
    },
    search: _.debounce(function () {
      this.load_zipcodes();
    }, 500),
    load_zipcodes: async function () {
      await Api.findAll('address_validation_zip_formats', {
        filter: { country_code: this.search_query }
      }).then(({ data: zipcodes }) => {
        this.zipcodes = zipcodes;
      });
    }
  },

  async mounted() {
    this.setBreadcrumbs([{ to: { name: 'zipcode_formats' }, text: 'Zipcode formats' }]);
  }
};
</script>

<style scoped></style>
